import { useQuery } from '@tanstack/react-query';

import { EventReportClient, EventReportListRequest } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const eventReportClient = new EventReportClient(apiBaseUrl);

function useGetEventReportsByType(request: EventReportListRequest) {
  return useQuery({
    queryKey: [queryKeys.EventReport.GetListByType, request],
    queryFn: () => eventReportClient.getEventReportList(request),
  });
}

export default useGetEventReportsByType;
